<div>
  <mat-icon [inline]="true">report</mat-icon>
  <h1 i18n>No rights for this page</h1>
</div>
